import { render, staticRenderFns } from "./InsufficientCourses.vue?vue&type=template&id=61eb49eb&scoped=true&"
import script from "./InsufficientCourses.vue?vue&type=script&lang=js&"
export * from "./InsufficientCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61eb49eb",
  null
  
)

export default component.exports